/**
 * Uniba Banner reducer
 * @module src/reducers/unibaBannerReducer
 */

import { GET_UNIBA_BANNER } from 'design-comuni-plone-theme/actions';

const initialState = {
  error: null,
  hasError: false,
  result: {},
  loadingResults: false,
};

export const unibaBannerReducer = (state = initialState, action = {}) => {
  switch (action.type) {
    case `${GET_UNIBA_BANNER}_PENDING`:
      return {
        ...state,
        loadingResults: true,
      };

    case `${GET_UNIBA_BANNER}_SUCCESS`:
      return {
        ...state,
        result: action.result,
        loadingResults: false,
      };

    case `${GET_UNIBA_BANNER}_FAIL`:
      return {
        ...state,
        error: action.error,
        hasError: true,
        loadingResults: false,
      };

    default:
      return state;
  }
};
